import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 12.376 9.563"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.165.961A.562.562 0 1 1 .961.165l5.227 5.228L11.415.165a.56.56 0 0 1 .796 0 .565.565 0 0 1 0 .796L6.586 6.586a.55.55 0 0 1-.398.165.57.57 0 0 1-.398-.165zm11.648 7.477H.563a.562.562 0 1 0 0 1.125h11.25a.562.562 0 1 0 0-1.125"
    }, null, -1)
  ])))
}
export default { render: render }